import "./App.css";
import { Calculator } from "./container";
import { Header } from "./container";

function App() {
  return (
    <div className="app">
      <Header />
      <Calculator />
    </div>
  );
}

export default App;
